/**
 * Industry list for the Research landing waitlist.
 * Укрупнённые сектора экономики (по-русски) — используются только на /research.
 * Для основной анкеты диагностики (q001_industry_primary) действует отдельный,
 * более детальный список — они не должны быть синхронизированы.
 */
export const INDUSTRIES = [
  "Сельское хозяйство",
  "Лесное хозяйство и рыболовство",
  "Добывающая промышленность",
  "Обрабатывающая промышленность",
  "Строительство",
  "Энергетика",
  "Транспорт и логистика",
  "Торговля и общественное питание",
  "Финансовый сектор",
  "Недвижимость",
  "Туризм и гостеприимство",
  "Административные услуги",
  "Связь и телекоммуникации",
  "ИТ и высокие технологии",
  "Образование и наука",
  "Здравоохранение и социальные услуги",
];
